const resources = [

/*{
    "name": "???",
    "expansion": "Core",
    "location": "Basic Resource",
    "flavorText": "You have no idea what monster bit this is. Can be used as a bone, organ or hide!",
    "text": null,
    "material": "Bone, Organ, or Hide",
    "consumable": false,
},*/


{
    "name": "???",
    "expansion": "Core",
    "location": "Basic Resource",
    "flavorText": "You have no idea what monster bit this is. Can be used as a bone, organ or hide!",
    "text": null,
    "material": "Bone, Organ, or Hide",
    "consumable": false,
},
{
    "name": "Broken Lantern",
    "expansion": "Core",
    "location": "Basic Resource",
    "flavorText": "Remains of an extinguished lantern.",
    "text": null,
    "material": "Scrap",
    "consumable": false,
},
{
    "name": "Love Juice",
    "expansion": "Core",
    "location": "Basic Resource",
    "flavorText": "Remains of an extinguished lantern.",
    "text": "During the settlement phase, you may archive this to 📖 Intimacy.\nNominated survivors must be able to consume.",
    "material": "Organ",
    "consumable": true,
},
{
    "name": "Lump of Atnas",
    "expansion": "White Box",
    "location": "Basic Resource",
    "flavorText": "Nostrils flare with delight. A pungent, pine scent emanates from the quivering cube.",
    "text": "At the start of the settlement phase, if there are 5 or more Cubes of Atnas in settlement storage, their scent draws a survivor, sniffing through the darkness. Gain +1 population, this survivor has a random disorder.",
    "material": "Bone, Organ, or Hide",
    "consumable": false,
},
{
    "name": "Monster Bone",
    "expansion": "Core",
    "location": "Basic Resource",
    "flavorText": "A bone suitable for crafting.",
    "text": "",
    "material": "Bone",
    "consumable": false,
},
{
    "name": "Monster Hide",
    "expansion": "Core",
    "location": "Basic Resource",
    "flavorText": "The skin of a beast.",
    "text": "",
    "material": "Hide",
    "consumable": false,
},
{
    "name": "Monster Organ",
    "expansion": "Core",
    "location": "Basic Resource",
    "flavorText": "",
    "text": "If you consume this, archive this card. Roll 1d10. On a result of 6+, you contract a parasite.\nArchive all consumable gear in your gear grid now.",
    "material": "Organ",
    "consumable": true,
},
{
    "name": "Perfect Bone",
    "expansion": "Core",
    "location": "Basic Resource",
    "flavorText": "A mind numbingly perfect bone.",
    "text": "",
    "material": "Bone, Perfect",
    "consumable": false,
},
{
    "name": "Perfect Hide",
    "expansion": "Core",
    "location": "Basic Resource",
    "flavorText": "Supreme texture.",
    "text": "",
    "material": "Hide, Perfect",
    "consumable": false,
},
{
    "name": "Perfect Organ",
    "expansion": "Core",
    "location": "Basic Resource",
    "flavorText": "",
    "text": "If you consume this, archive this card. Roll 1d10. On a result of 6+, you contract a millennium parasite and gain +10 Hunt XP.",
    "material": "Organ, Perfect",
    "consumable": true,
},
{
    "name": "Skull",
    "expansion": "Core",
    "location": "Basic Resource",
    "flavorText": "",
    "text": "When you gain this, a survivor of your choice gains +1 insanity.",
    "material": "Bone",
    "consumable": false,
},
{
    "name": "Curious Hand",
    "expansion": "Core",
    "location": "White Lion",
    "flavorText": "Holding this fills you with sadness.",
    "text": "When you gain this, a random survivor gains +1 insanity.",
    "material": "Hide",
    "consumable": false,
},
{
    "name": "Eye of Cat",
    "expansion": "Core",
    "location": "White Lion",
    "flavorText": "A perfectly preserved eye.",
    "text": "",
    "material": "Organ",
    "consumable": true,
},
{
    "name": "Golden Whiskers",
    "expansion": "Core",
    "location": "White Lion",
    "flavorText": "These whiskers are tough!",
    "text": "",
    "material": "Organ",
    "consumable": false,
},
{
    "name": "Great Cat Bones",
    "expansion": "Core",
    "location": "White Lion",
    "flavorText": "Strong and surprisingly light.",
    "text": "",
    "material": "Bone",
    "consumable": false,
},
{
    "name": "Lion Claw",
    "expansion": "Core",
    "location": "White Lion",
    "flavorText": "A razor-sharp, retractable claw.",
    "text": "",
    "material": "Bone",
    "consumable": false,
},
{
    "name": "Lion Tail",
    "expansion": "Core",
    "location": "White Lion",
    "flavorText": "It's surprisingly heavy.",
    "text": "",
    "material": "Hide",
    "consumable": false,
},
{
    "name": "Lion Testes",
    "expansion": "Core",
    "location": "White Lion",
    "flavorText": "A hefty pair of nuts.",
    "text": "",
    "material": "Organ",
    "consumable": true,
},
{
    "name": "Shimmering Mane",
    "expansion": "Core",
    "location": "White Lion",
    "flavorText": "It shimmers in the lantern light.",
    "text": "Archive this to gain 2 basic hide resources.",
    "material": "Hide",
    "consumable": false,
},
{
    "name": "Sinew",
    "expansion": "Core",
    "location": "White Lion",
    "flavorText": "These stringy guts are quite useful.",
    "text": "",
    "material": "Organ",
    "consumable": false,
},
{
    "name": "White Fur",
    "expansion": "Core",
    "location": "White Lion",
    "flavorText": "Luxurious and soft to the touch.",
    "text": "",
    "material": "Hide",
    "consumable": false,
},
{
    "name": "Beast Steak",
    "expansion": "Core",
    "location": "Screaming Antelope",
    "flavorText": "Shockingly Appetizing.",
    "text": "",
    "material": "Organ",
    "consumable": true,
},
{
    "name": "Bladder",
    "expansion": "Core",
    "location": "Screaming Antelope",
    "flavorText": "Smells like urine.",
    "text": "",
    "material": "Organ",
    "consumable": true,
},
{
    "name": "Large Flat Tooth",
    "expansion": "Core",
    "location": "Screaming Antelope",
    "flavorText": "Its surface is rough and bumpy.",
    "text": "When you gain this, a survivor of your choice gains +1 insanity.",
    "material": "Bone",
    "consumable": false,
},
{
    "name": "Muscly Gums",
    "expansion": "Core",
    "location": "Screaming Antelope",
    "flavorText": "Difficult to pry apart.",
    "text": "",
    "material": "Organ",
    "consumable": true,
},
{
    "name": "Pelt",
    "expansion": "Core",
    "location": "Screaming Antelope",
    "flavorText": "Coarse and warm.",
    "text": "",
    "material": "Hide",
    "consumable": false,
},
{
    "name": "Screaming Brain",
    "expansion": "Core",
    "location": "Screaming Antelope",
    "flavorText": "",
    "text": "Consume: Archive this and gain survival up to the current limit.",
    "material": "Organ",
    "consumable": true,
},
{
    "name": "Shank Bone",
    "expansion": "Core",
    "location": "Screaming Antelope",
    "flavorText": "Strangely jointed.",
    "text": "",
    "material": "Bone",
    "consumable": false,
},
{
    "name": "Spiral Horn",
    "expansion": "Core",
    "location": "Screaming Antelope",
    "flavorText": "Moans balefully when blown.",
    "text": "",
    "material": "Bone",
    "consumable": false,
},

];

export default resources;